<template>
<div class="min-h-screen flex flex-col py-6 bg-gray-50 sm:px-6 sm:py-12 lg:px-8">

  <div class="pt-12 sm:mx-auto sm:w-full sm:max-w-md lg:pt-16">
    <transition name="fade" mode="out-in">
      <div v-if="!isLoading" key="content" class="bg-white pb-8 px-4 shadow sm:rounded-lg sm:px-10">


        <!-- TUTOR INFO -->
      
        <div class="flex justify-center">
          <img :src="tutor.Photo" class="-mt-12 h-24 w-24 lg:-mt-16 lg:h-32 lg:w-32 rounded-full" alt=""  @click="$refs.amount.focus()" />
        </div>

        <p class="mt-4 text-sm text-center text-gray-500">
          Make a payment to
        </p>

        <h2 class="mt-1 text-center text-2xl font-semibold text-gray-800">
          {{ tutor.Name }}
        </h2>

        <div class="-mt-1 text-center">
          <router-link
            :to="{ name: 'Tutor', params: { id: $route.params.id } }"
            class="inline-flex items-center space-x-1 text-xs text-gray-400"
            target="_blank"
          >
            <span>View Profile</span>
            <ExternalLinkIcon class="w-4 h-4 text-gray-300" />
          </router-link>
        </div>

        


        <div class="mt-6">

        <!-- PAYER DETAILS -->

          <transition name="fade" mode="out-in">
            <form v-if="showPayerDetails" @submit.prevent="submitPayerDetails" class="space-y-6">

              <div class="space-y-1">
                <label for="payersName" class="block text-sm text-gray-700 mx-auto">
                  Your Name
                </label>
                <input 
                  v-model="payersName"
                  id="payersName" 
                  autocomplete="name"
                  class="block w-full px-4 py-3 rounded-md shadow-sm border border-gray-300 text-base text-gray-800 placeholder-gray-400 font-medium bg-transparent focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:flex-1"
                />
                <p v-if="$v.payersName.$dirty && !$v.payersName.required" class="text-sm text-red-600">Please enter your name.</p>
              </div>

              <div class="space-y-1">
                <label for="payersEmail" class="block text-sm text-gray-700 mx-auto">
                  Email address
                </label>
                <input 
                  v-model="payersEmail"
                  id="payersEmail" 
                  autocomplete="email"
                  inputmode="email"
                  type="email"
                  class="block w-full px-4 py-3 rounded-md shadow-sm border border-gray-300 text-base text-gray-800 placeholder-gray-400 font-medium bg-transparent focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:flex-1"
                />
                <p v-if="$v.payersEmail.$dirty && !$v.payersEmail.required" class="text-sm text-red-600">Please enter your email address.</p>
                <p v-if="$v.payersEmail.$dirty && !$v.payersEmail.email" class="text-sm text-red-600">Please enter a valid email address.</p>
              </div>

              <div class="space-y-1">
                <label for="payersTelephone" class="block text-sm text-gray-700 mx-auto">
                  Phone number
                </label>
                <input 
                  v-model="payersTelephone"
                  id="payersTelephone" 
                  autocomplete="tel"
                  inputmode="tel"
                  type="tel"
                  class="block w-full px-4 py-3 rounded-md shadow-sm border border-gray-300 text-base text-gray-800 placeholder-gray-400 font-medium bg-transparent focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:flex-1"
                />
                <p v-if="$v.payersTelephone.$dirty && !$v.payersTelephone.required" class="text-sm text-red-600">Please enter a contact number.</p>
              </div>

              <div class="flex items-center">
                <input 
                  v-model="rememberPayerDetails" 
                  id="rememberPayerDetails" 
                  type="checkbox" 
                  class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <label for="rememberPayerDetails" class="ml-2 block text-sm text-gray-900">
                  Remember my details on this device
                </label>
              </div>

              <button type="submit" class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                Next
              </button>

            </form>
            <div v-else-if="showTransactionScreen || showAmountScreen" class="p-4 bg-gray-50 flex justify-between rounded-md" :class="{ 'rounded-b-none': showAmountScreen }">
              <div>
                <!-- <span class="block text-xs uppercase text-gray-400 mb-1.5">Your Details</span> -->
                <span class="block text-gray-800 font-medium leading-tight">{{ payersName }}</span>
                <span class="block text-sm text-gray-600">{{ payersEmail }}</span>
                <span class="block text-sm text-gray-600">{{ payersTelephone }}</span>
              </div>
              <div class="flex flex-col justify-between py-0.5">
                <button type="button" @click="screen = 'payer'">
                  <PencilAltIcon class="w-5 h-5 text-gray-400" />
                </button>
                <button v-if="payerDetailsSaved" type="button" @click="deletePayer">
                  <TrashIcon class="w-5 h-5 text-gray-400 opacity-50" />
                </button>
              </div>
            </div>

          </transition>



          <!-- TRANSACTION DETAILS -->

          <transition name="fade" mode="out-in">

            <form v-if="showTransactionScreen" @submit.prevent="submitTransaction" class="mt-6 space-y-6">

              <!-- <hr class="bg-gray-300" /> -->

              <div class="space-y-1">
                <label for="studentsName" class="block text-sm text-gray-700 mx-auto">
                  Student’s name
                </label>
                <input 
                  v-model="studentsName"
                  id="studentsName" 
                  class="block w-full px-4 py-3 rounded-md shadow-sm border border-gray-300 text-base text-gray-800 placeholder-gray-400 font-medium bg-transparent focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:flex-1"
                />
                <div>
                  <div
                    v-for="item of recentStudentNames"
                    :key="item.key"
                    class="inline-flex mr-2"
                  >
                    <button 
                      type="button"
                      @click="studentsName = item"
                      :title="`Use ${item}`"
                      class="py-0.5 pl-2 pr-0.5 rounded-l-full text-xs font-medium bg-gray-100 text-gray-700 cursor-pointer hover:bg-gray-200 hover:text-gray-800 focus:outline-none focus:bg-gray-500 focus:text-white"
                    >
                      {{ item }}
                    </button>
                    <button type="button" @click="removeStudent(item)" class="py-0.5 pr-2 pl-0.5 rounded-r-full text-xs font-medium bg-gray-100 text-gray-400 cursor-pointer hover:bg-gray-200 hover:text-gray-500 focus:outline-none focus:bg-gray-500 focus:text-white">
                      <span class="sr-only">Remove</span>
                      <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                        <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7" />
                      </svg>
                    </button>
                  </div>
                  <button
                    type="button"
                    @click="studentsName = payersName"
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 hover:bg-gray-200 hover:text-gray-800 focus:outline-none focus:bg-gray-500 focus:text-white"
                  >
                    {{ payersName }}
                  </button>
                </div>
                <p v-if="$v.studentsName.$dirty && !$v.studentsName.required" class="text-sm text-red-600">Please enter the name of the student.</p>
              </div>

              <div class="space-y-1">
                <label for="reasonForPayment" class="block text-sm text-gray-700">Reason for payment</label>
                <select v-model="reasonForPayment" id="reasonForPayment" class="block w-full pl-4 pr-10 py-3 text-base text-gray-800 border-gray-300 font-medium shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 rounded-md">
                  <option 
                    v-for="item of transactionTypes"
                    :key="item.selectLabel"
                    :value="item"
                  >
                    {{ item.selectLabel }}
                  </option>
                  <!-- <option>Lesson Fees</option>
                  <option>Learning Resources</option>
                  <option>Other</option> -->
                </select>
              </div>

              <div class="space-y-1">
                <label for="description" class="block text-sm text-gray-700 mx-auto">
                  {{ selectedTransactionType.descLabel }}
                </label>
                <input 
                  :value="selectedTransactionType.descType === 'date' ? lessonDate : description"
                  @input="selectedTransactionType.descType === 'date' ? lessonDate = $event.target.value : description = $event.target.value"
                  id="description" 
                  :type="selectedTransactionType.descType"
                  class="block w-full px-4 py-3 rounded-md shadow-sm border border-gray-300 text-base text-gray-800 placeholder-gray-400 font-medium bg-transparent focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:flex-1"
                />
                <p v-if="$v.description.$dirty && !$v.description.required" class="text-sm text-red-600">Please specify what this payment is for.</p>
              </div>

              <div>
                <button type="submit" class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                  Next
                </button>
              </div>
            </form>
            <div v-else-if="showAmountScreen" class="p-4 flex justify-between bg-gray-50 rounded-b-md border-t border-white">

              <!-- <hr class="bg-gray-300" /> -->

              <div>
                <!-- <span class="block text-xs uppercase text-gray-400 mb-1.5">Transaction</span> -->
                <span class="block text-sm text-gray-600">{{ transactionSummary }}</span>
                <span v-if="studentsName !== payersName" class="block text-sm text-gray-600">
                  On behalf of <span class="text-gray-800 font-medium">{{ studentsName }}</span>
                </span>
              </div>
              <div class="flex flex-col justify-between py-0.5">
                <button type="button" @click="screen = 'transaction'">
                  <PencilAltIcon class="w-5 h-5 text-gray-400" />
                </button>
              </div>
            </div>

          </transition>



          <!-- AMOUNT -->

          <transition name="fade" mode="out-in">

            <form v-if="showAmountScreen" @submit.prevent="submitAmount" class="mt-10 space-y-10">

              <!-- <hr class="bg-gray-300" /> -->

              <div class="">
                <label for="amount" class="block mb-3 text-sm text-gray-700 text-center mx-auto w-32">
                  Amount to pay
                </label>
                <div class="flex items-center rounded-md mx-auto px-3 w-40 relative">
                  <div  @click="$refs.amount.focus()" class="bg-red-500 opacity-0 absolute inset-0">
                    <!--
                      This transparent element sits above the input field
                      to capture the click even and ensure the focus script
                      can be run, putting the cursor at the end of the field
                    -->
                  </div>
                  <span class="text-gray-600 text-xl font-medium">
                    £
                  </span>
                  <input  
                    ref="amount"
                    id="amount" 
                    :value="amount"
                    @input="amountChanged($event.target.value)"
                    @focus="amountFocused"
                    inputmode="numeric"
                    :placeholder="amount"
                    maxlength="6"
                    class="block w-full text-transparent text-3xl leading-tight text-gray-800 placeholder-gray-400 text-center font-medium bg-transparent focus:outline-none sm:flex-1"
                  />
                </div>
                <p
                  v-if="$v.amount.$dirty && $v.amount.$invalid"
                  class="text-sm text-red-600 text-center"
                >
                  <!-- <template v-if="!$v.amount.decimal">Please enter a valid number.</template> -->
                  <template v-if="!$v.amount.required">Please enter an amount.</template>
                  <template v-else-if="!$v.amount.minValue">Minimum amount is £1.</template>
                  <template v-else-if="!$v.amount.maxValue">Payment cannot exceed £999.99.</template>
                </p>
                <div v-if="recentPayments.length > 0" class="mt-4 flex justify-center items-center space-x-3">
                  <span class="text-xs text-gray-400">
                    <span class="hidden sm:inline">Previous payments:</span>
                    <span class="sm:hidden">Previously:</span>
                  </span>
                  <button
                    v-for="payment of recentPayments"
                    :key="payment"
                    type="button"
                    @click="amount = parseFloat(payment).toFixed(2)"
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 hover:bg-gray-200 hover:text-gray-800 focus:outline-none focus:bg-gray-500 focus:text-white"
                  >
                    £{{ payment.replace('.00', '') }}
                  </button>
                </div>
              </div>

              <div>
                <button type="submit" class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                  Next
                </button>
                <p class="mt-2 text-xs text-gray-500 text-center">You will be taken to stripe.com to complete your payment.</p>
              </div>
            </form>

          </transition>


          <transition name="fade" mode="out-in">
            <div v-if="showStripeScreen" class="py-10 flex flex-col items-center">
              
              <p class="mb-6 text-gray-600 font-medium">
                <template v-if="preparingTransaction">
                  Preparing transaction…
                </template>
                <template v-else-if="redirecting">
                  Redirecting to stripe.com…
                </template>
              </p>

              <!-- By Sam Herbert (@sherb), for everyone. More @ http://goo.gl/7AJzbL -->
              <svg width="38" height="38" fill="blue" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                      <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
                          <stop stop-color="#2563eb" stop-opacity="0" offset="0%"/>
                          <stop stop-color="#2563eb" stop-opacity=".631" offset="63.146%"/>
                          <stop stop-color="#2563eb" offset="100%"/>
                      </linearGradient>
                  </defs>
                  <g fill="none" fill-rule="evenodd">
                      <g transform="translate(1 1)">
                          <path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#a)" stroke-width="2">
                              <animateTransform
                                  attributeName="transform"
                                  type="rotate"
                                  from="0 18 18"
                                  to="360 18 18"
                                  dur="0.9s"
                                  repeatCount="indefinite" />
                          </path>
                          <circle fill="#fff" cx="36" cy="18" r="1">
                              <animateTransform
                                  attributeName="transform"
                                  type="rotate"
                                  from="0 18 18"
                                  to="360 18 18"
                                  dur="0.9s"
                                  repeatCount="indefinite" />
                          </circle>
                      </g>
                  </g>
              </svg>



            </div>
          </transition>

        </div>
        

        
      </div>
      <div v-else key="loading" class="h-60 bg-gray-200 animate-pulse sm:rounded-lg">
        <!-- Loading -->
      </div>
    </transition>
  </div>

  <div class="mt-6 mx-auto px-4 w-full flex justify-between items-center sm:px-0 sm:max-w-md">
    <router-link :to="{ name: 'Home' }">
      <img src="../assets/TheTutorIndex-logo-horizontal.svg" alt="The Tutor Index" class="h-3" />
    </router-link>
    <div class="flex items-center">
      <span class="text-xs text-gray-500">Secured by</span>
      <img src="../assets/stripe-wordmark-slate.svg" alt="Stripe" class="mt-px h-5 opacity-60" />
    </div>
  </div>

  <!-- <div class="mt-2 mx-auto px-4 w-full text-center sm:px-0 sm:max-w-md">
    <router-link :to="{ name: 'UserAgreement' }" class="text-xs text-gray-500 underline">Payment Agreement</router-link>
  </div> -->

</div>
</template>


<script>
import { required, requiredIf, minValue, maxValue, email } from 'vuelidate/lib/validators'
import { ExternalLinkIcon, PencilAltIcon, TrashIcon } from '@vue-hero-icons/solid'

import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
dayjs.extend(advancedFormat)

import Cookie from 'js-cookie'

import TutorService from '@/services/TutorServices'
const tutorService = new TutorService()

import StripeServices from '@/services/StripeServices'
const stripeService = new StripeServices()

const transactionTypes = [
  { selectLabel: 'Lesson Fees', descLabel: 'Date of lesson (Optional)', descType: 'date', required: false },
  { selectLabel: 'Learning Resources', descLabel: 'Description (Optional)', descType: 'text', required: false },
  { selectLabel: 'Other', descLabel: 'Description', descType: 'text', required: true },
]

const PAYERINFO_COOKIENAME = 'PayerInfo'
const RECENTSTUDENTS_COOKIENAME = 'Students'
const RECENTPAYMENTS_COOKIENAME = 'RecentPayments'
const STRIPECUSTOMERID_COOKIENAME = 'stcid'

export default {
  components: {
    ExternalLinkIcon,
    PencilAltIcon,
    TrashIcon,
  },
  data() {
    return {
      isLoading: true,
      tutor: {},
      amount: '0.00',
      screen: 'payer',
      payersName: null,
      payersEmail: null,
      payersTelephone: null,
      rememberPayerDetails: true,
      payerDetailsSaved: false,
      studentsName: null,
      reasonForPayment: transactionTypes[0],
      description: null,
      transactionTypes,
      recentStudentNames: [],
      recentPayments: [],
      stripeStatus: null,
      lessonDate: null,
    }
  },
  metaInfo() {
    return {
      title: `Pay ${this.tutor?.Name} | The Tutor Index`,
    }
  },
  validations() {
    return {
      payersName: {
        required,
      },
      payersEmail: {
        required,
        email,
      },
      payersTelephone: {
        required,
      },
      studentsName: {
        required,
      },
      description: {
        required: requiredIf(vm => {
          return vm.reasonForPayment.required
        })
      },
      amount: {
        required,
        minValue: minValue(1),
        maxValue: maxValue(999.99),
      }
    }
  },
  computed: {
    showPayerDetails() { return this.screen === 'payer' },
    showTransactionScreen() { return this.screen === 'transaction' },
    showAmountScreen() { return this.screen === 'amount' },
    showStripeScreen() { return this.screen === 'stripe' },
    preparingTransaction() { return this.stripeStatus === 'preparing' },
    redirecting() { return this.stripeStatus === 'redirecting' },
    selectedTransactionType() {
      this.description = null
      return this.transactionTypes.find(x => x.selectLabel === this.reasonForPayment.selectLabel)
    },
    transactionSummary() {
      switch (this.selectedTransactionType.selectLabel) {
        case 'Lesson Fees':
          return this.description
            ? `Lesson fees for ${dayjs(this.description).format('dddd Do MMMM YYYY')}`
            : `Lesson Fees`
      
        case 'Learning Resources':
          return this.description
            ? `Learning Resources: ${this.description}`
            : 'Learning Resources'

        case 'Other':
          return this.description
      }
    },
  },
  methods: {
    submitPayerDetails() {
      // Validate
      this.$v.payersName.$touch()
      this.$v.payersEmail.$touch()
      this.$v.payersTelephone.$touch()
      
      if (this.$v.payersName.$invalid
        || this.$v.payersEmail.$invalid
        || this.$v.payersTelephone.$invalid)
        return

      if (this.rememberPayerDetails) {
        Cookie.set(
          PAYERINFO_COOKIENAME, 
          JSON.stringify({ payersName: this.payersName, payersEmail: this.payersEmail, payersTelephone: this.payersTelephone }),
          { expires: 60, secure: true },
        )
        this.payerDetailsSaved = true
      }
      
      this.screen = ''
      setTimeout(() => this.screen = 'transaction', 300)
    },
    submitTransaction() {
      // Validate
      this.$v.studentsName.$touch()
      this.$v.description.$touch()

      if (this.$v.studentsName.$invalid
        || this.$v.description.$invalid)
        return

      const index = this.recentStudentNames.indexOf(this.studentsName)
      if (index > -1) {
        // Remove any existing matches from current position in list
        this.recentStudentNames.splice(index, 1)
      }

      if (this.studentsName !== this.payersName) {
        this.recentStudentNames.unshift(this.studentsName)
      }
      
      this.recentStudentNames = this.recentStudentNames.slice(0, 3)

      if (this.rememberPayerDetails) {
        Cookie.set(
          RECENTSTUDENTS_COOKIENAME,
          JSON.stringify(this.recentStudentNames),
          { expires: 60, secure: true },
        )
      }

      this.screen = ''
      setTimeout(() => this.screen = 'amount', 300)
    },
    submitAmount() {
      // Validate
      this.$v.amount.$touch()

      if (this.$v.amount.$invalid)
        return

      const index = this.recentPayments.indexOf(this.amount)
      if (index > -1) {
        // Remove any existing matches from current position in list
        this.recentPayments.splice(index, 1)
      }

      this.recentPayments.unshift(this.amount)
      this.recentPayments = this.recentPayments.slice(0, 3)

      Cookie.set(
        RECENTPAYMENTS_COOKIENAME,
        JSON.stringify(this.recentPayments),
        { expires: 60, secure: true },
      )

      this.screen = ''
      setTimeout(() => this.screen = 'stripe', 300)
      this.beginPayment()
    },
    async beginPayment() {
      this.stripeStatus = 'preparing'

      const response = await stripeService.preparePayment({
        publicTutorId: this.$route.params.id,
        payersName: this.payersName,
        payersEmail: this.payersEmail,
        payersTelephone: this.payersTelephone,
        studentsName: this.studentsName,
        reasonForPayment: this.reasonForPayment.selectLabel,
        lessonDate: this.lessonDate,
        description: this.description,
        transactionSummary: this.transactionSummary,
        onBehalfOf: this.studentsName,
        amount: this.amount,
        stripeCustomerId: Cookie.get(STRIPECUSTOMERID_COOKIENAME)
      })

      
      this.stripeStatus = 'redirecting'

      if (this.rememberPayerDetails) {
        Cookie.set(
          STRIPECUSTOMERID_COOKIENAME, 
          response.data.CustomerId,
          { expires: 60, secure: true },
        )
      }

      setTimeout(() =>
        // Give them half a second to process the wording
        window.location.href = response.data.StripeRedirectUrl
      , 500)
      
    },
    deletePayer() {
      Cookie.remove(PAYERINFO_COOKIENAME)
      this.payersName = ''
      this.payersEmail = ''
      this.payersTelephone = ''
      this.payerDetailsSaved = false
      this.screen = 'payer'
    },
    removeStudent(student) {
      const index = this.recentStudentNames.indexOf(student)
      this.recentStudentNames.splice(index, 1)
      if (this.rememberPayerDetails) {
        Cookie.set(
          RECENTSTUDENTS_COOKIENAME,
          JSON.stringify(this.recentStudentNames),
          { expires: 60, secure: true },
        )
      }
    },
    amountChanged(newVal) {
      // Combination of the following plys some own code
      // https://stackoverflow.com/questions/43930384/how-to-start-input-number-as-decimal-format-from-right-to-left-by-using-javascri
      // https://github.com/s-yadav/react-number-format/issues/197
      if (!newVal) newVal = '0.00'
      let amount = ''
      newVal = newVal.replace('.', '')
      amount = (parseInt(newVal) / 100).toFixed(2)
      this.amount = '0'
      this.$nextTick(() => this.amount = `${amount}`)
    },
    amountFocused() {
      // This doesn't seem to work if clicking the input
      // directly, but will fire and correctly place the cursor
      // if the click happens on another element, for example
      // a transparent box placed over the top of the input.
      // https://www.geeksforgeeks.org/how-to-place-cursor-position-at-end-of-text-in-text-input-field-using-javascript/
      const len = this.amount.length
        
      // Mostly for Web Browsers
      if (this.$refs.amount.setSelectionRange) {
          this.$refs.amount.focus()
          this.$refs.amount.setSelectionRange(len, len)
      } else if (this.$refs.amount.createTextRange) {
          const t = end.createTextRange()
          t.collapse(true);
          t.moveEnd('character', len)
          t.moveStart('character', len)
          t.select()
      }
    },
  },
  async mounted() {

    const [tutorResponse, acceptsPaymentResponse] = await Promise.all([
      tutorService.get(this.$route.params.id),
      tutorService.canAcceptPayments(this.$route.params.id),
    ])

    if (!acceptsPaymentResponse.data) {
      this.$router.push({ name: 'PayTutorDisabled', params: this.$route.params })
      return
    }

    this.tutor = tutorResponse.data

    this.isLoading = false

    const payerInfoCookie = Cookie.get(PAYERINFO_COOKIENAME)
    if (payerInfoCookie) {
      const payerInfo = JSON.parse(payerInfoCookie)
      this.payersName = payerInfo.payersName
      this.payersEmail = payerInfo.payersEmail
      this.payersTelephone = payerInfo.payersTelephone
      this.screen = 'transaction'
      this.payerDetailsSaved = true
    }

    const recentStudentNamesCookie = Cookie.get(RECENTSTUDENTS_COOKIENAME)
    if (recentStudentNamesCookie) {
      this.recentStudentNames = JSON.parse(recentStudentNamesCookie)
    }

    const recentPaymentsCookie = Cookie.get(RECENTPAYMENTS_COOKIENAME)
    if (recentPaymentsCookie) {
      this.recentPayments = JSON.parse(recentPaymentsCookie)
    }
  },
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>